<template>
  <a-data-table
    :items="filterSurveyData"
    :headers="headers"
    :items-per-page="10"
    style="width: 100%"
    :footer-props="{
      'items-per-page-text': $t('lblRowsPerPage'),
    }"
    sort-by="title"
    :sort-desc="false"
    :must-sort="true"
  >
    <template v-slot:[`item.surveyParticipant`]="{ item }">
      <survey-target-list :items="item.surveyParticipant"></survey-target-list>
    </template>
    <template v-slot:[`item.title`]="{ item }">
      <span style="font-weight: 700" v-if="item.isDeleted">{{
        item.title
      }}</span>
      <router-link
        v-else
        style="cursor: pointer; display: inline-flex; font-weight: 700"
        :to="`/survey/${item.id}/tenant/${tenantId}/search`"
      >
        <span class="routerLink-survey"> {{ item.title }}</span>
      </router-link>
    </template>
    <template v-slot:[`item.startDate`]="{ item }">
      <div style="color: #333333">
        {{ formatDate(new Date(item.startDate), "MM/dd/yyyy h:mm aaa") }}
      </div>
    </template>
    <template v-slot:[`item.endDate`]="{ item }">
      <div style="color: #333333">
        {{ formatDate(new Date(item.endDate), "MM/dd/yyyy h:mm aaa") }}
      </div>
    </template>
    <template v-slot:[`item.createdDate`]="{ item }">
      <div style="color: #333333">
        {{ formatDate(new Date(item.createdDate), "MM/dd/yyyy h:mm aaa") }}
      </div>
    </template>
  </a-data-table>
</template>

<script>
import { formatDate } from "@/utils/util";
import { mapState } from "vuex";
import SurveyTargetList from "./SurveyTargetList.vue";
export default {
  components: { SurveyTargetList },
  name: "SurveySearch",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      pollSurveyQuestions: (state) => state.poll.pollSurveyQuestions,
    }),
    headers() {
      return [
        {
          value: "title",
          text: this.$t("title"),
          type: "survey",
          class: "header header-text",
          width: 400,
        },
        {
          value: "surveyParticipant",
          text: "Survey target",
          type: "survey",
          class: "header header-text",
          sortable: false,
        },
        {
          value: "startDate",
          text: this.$t("search.startDate"),
          type: "survey",
          class: "header header-text",
        },
        {
          value: "endDate",
          text: this.$t("search.endDate"),
          type: "survey",
          class: "header header-text",
        },
        {
          value: "createdDate",
          text: this.$t("admin.createdDate"),
          type: "survey",
          class: "header header-text",
        },
      ];
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    filterSurveyData() {
      let data = this.items.map((obj) => {
        return {
          ...obj,
          isDeleted: !this.pollSurveyQuestions.some(
            (item) => item.id === obj.id
          ),
        };
      });
      return data
        .filter((item) => item.type === "survey")
        .sort((a, b) => {
          if (a.title < b.title) return 1;
          if (a.title > b.title) return -1;
          return 0;
        });
    },
  },
  methods: {
    formatDate,
  },
};
</script>

<style scoped>
.routerLink-survey {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 370px;
}
</style>